import React, { SVGProps } from "react";

const NumberFormatIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_868_23995"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path d="M2 2H22V22H2V2Z" fill="white" />
      </mask>
      <g mask="url(#mask0_868_23995)">
        <path
          d="M10.7438 6.97925V6.35167C10.7438 6.0187 10.6117 5.69944 10.376 5.46409C10.1407 5.2287 9.82156 5.09644 9.48859 5.09644C9.15566 5.09644 8.83652 5.2287 8.60113 5.46409C8.36551 5.69944 8.23336 6.0187 8.23336 6.35167V6.97925H7.60578C7.27285 6.97925 6.95371 7.11148 6.71836 7.34691C6.4827 7.5823 6.35059 7.90151 6.35059 8.23444C6.35059 8.56737 6.4827 8.88663 6.71836 9.12198C6.95371 9.35741 7.27285 9.48968 7.60578 9.48968H8.23336V12.0001H7.60578C7.27285 12.0001 6.95371 12.1323 6.71836 12.3677C6.4827 12.6031 6.35059 12.9224 6.35059 13.2553C6.35059 13.5882 6.4827 13.9075 6.71836 14.1428C6.95371 14.3783 7.27285 14.5105 7.60578 14.5105H8.23336V15.1381C8.23336 15.471 8.36551 15.7903 8.60113 16.0257C8.83652 16.261 9.15566 16.3933 9.48859 16.3933C9.82156 16.3933 10.1407 16.261 10.376 16.0257C10.6117 15.7903 10.7438 15.471 10.7438 15.1381V14.5105H13.2543V15.1381C13.2543 15.471 13.3863 15.7903 13.622 16.0257C13.8573 16.261 14.1765 16.3933 14.5094 16.3933C14.8424 16.3933 15.1615 16.261 15.3969 16.0257C15.6325 15.7903 15.7646 15.471 15.7646 15.1381V14.5105H16.3923C16.7252 14.5105 17.0443 14.3783 17.2796 14.1428C17.5154 13.9075 17.6474 13.5882 17.6474 13.2553C17.6474 12.9224 17.5154 12.6031 17.2796 12.3677C17.0443 12.1323 16.7252 12.0001 16.3923 12.0001H15.7646V9.48968H16.3923C16.7252 9.48968 17.0443 9.35741 17.2796 9.12198C17.5154 8.88663 17.6474 8.56737 17.6474 8.23444C17.6474 7.90151 17.5154 7.5823 17.2796 7.34691C17.0443 7.11148 16.7252 6.97925 16.3923 6.97925H15.7646V6.35167C15.7646 6.0187 15.6325 5.69944 15.3969 5.46409C15.1615 5.2287 14.8424 5.09644 14.5094 5.09644C14.1765 5.09644 13.8573 5.2287 13.622 5.46409C13.3863 5.69944 13.2543 6.0187 13.2543 6.35167V6.97925H10.7438ZM10.7438 12.0001H13.2543V9.48964H10.7438V12.0001Z"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.1585 3.84117C20.1585 3.14793 19.5964 2.58594 18.9033 2.58594H5.09598C4.40281 2.58594 3.84082 3.14793 3.84082 3.84117V17.6484C3.84082 17.9814 3.97289 18.3006 4.20859 18.536C4.44391 18.7714 4.76305 18.9037 5.09598 18.9037H9.48922L11.9996 21.4141L14.51 18.9037H18.9033C19.2362 18.9037 19.5554 18.7714 19.7907 18.536C20.0264 18.3006 20.1585 17.9814 20.1585 17.6484V3.84117Z"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default NumberFormatIcon;
